
import { css } from 'lit';
export default css`
pc-header [slot='primary'] .main-menu{
  background-color:var(--purple-indigo);
  color:var(--neutral-charcoal);
}

pc-header .utility-menu{
  gap:var(--spacing-8);
  columns:2;
}

@media (max-width: 991px){
  pc-header .utility-menu li{
    margin-bottom:var(--spacing-6);
  }

  pc-header pc-form{
    display:block;
    max-width:calc(100% - (1.5rem + 41px));
  }

  .overlay-header{
    display:none;
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    opacity:0.15;
    z-index:1;
    background-color:var(--neutral-charcoal);
  }

  .overlay-header.is-visible{
    display:block;
  }
}

@media (min-width: 992px){
  pc-header .utility-menu{
    display:flex;
    columns:auto;
  }
}

pc-header .link-list-wrapper{
    display:grid;
    gap:2rem;
    margin-top:2rem;
  }

pc-header .link-list-wrapper ul{
      display:flex;
      flex-direction:column;
      gap:var(--spacing-6);
      color:var(--neutral-charcoal);
      font-size:var(--fs-h5-mobile);
      line-height:var(--lh-h5);
    }

pc-header .link-list-wrapper pc-heading{
      margin-bottom:1.5rem;
    }

pc-header .link-list a:hover{
      text-decoration:underline;
    }

@media (min-width: 992px){
    pc-header .link-list-wrapper{
      grid-template-columns:repeat(2, minmax(0, 1fr));
    }

      pc-header .link-list-wrapper ul{
        font-size:var(--fs-h5);
      }
}
`;